import {Component} from '@angular/core';
import {RouterLink, RouterOutlet} from "@angular/router";
import {AuthenticationService} from "../../_auth/authentication.service";
import {AppRoutes} from "../../enums/routes";

@Component({
  selector: 'app-self-service',
  imports: [
    RouterOutlet,
    RouterLink
  ],
  templateUrl: './self-service.component.html',
  styleUrl: './self-service.component.scss'
})
export class SelfServiceComponent {
  protected readonly Routes = AppRoutes;

  constructor(public AuthenticationService: AuthenticationService) {
  }
}
